export default __webpack_public_path__ + "dfbbabac6fbca59343a3cbcedeb59c36.png";